import initialState from 'SRC/modules/redux/initialState'
import actionTypes from 'SRC/modules/redux/actionTypes'

export const adsWithPromosPaginationReducer = (state = initialState.ads.adsWithPromosPagination, action) => {
  switch (action.type) {
    case actionTypes.SET_ADS_WITH_PROMOS_PAGINATION_PARAMS:
      return {
        ...state,
        params: action.payload
      }
    default:
      return state
  }
}
